// Import Services
import Services from '../core/services'

export default {

  getMembers( ) {
    return new Promise((resolve) => {
      return Services
        .get("api/accountmanagement/members")
        .then( ({data}) => {
          if (data && data.success) {
            return resolve({
              household: {
                number: data.householdNumber,
                name: data.householdName,
                address: [data.householdAddress1, data.householdAddress2],
                city: data.householdCity,
                state: data.householdState,
                zip: data.householdZip,
              },
              primaryEmail: data.primaryEmail || "",
              members: data.members || [],
            });
          }

          return resolve({});
        })
        .catch(() => {
          return resolve({});
        });
    });
  },

  inviteMember( memberId, emailAddress ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/accountmanagement/invite/${memberId}`, {
          emailAddress
        })
        .then( ({data}) => {
          return resolve(data);
        })
        .catch(() => {
          return resolve(null);
        });
    });
  },

  changeMemberStatus( memberId, status ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/accountmanagement/status/${memberId}`, {
          status: status,
        })
        .then( ({data}) => {
          return resolve(data);
        })
        .catch(() => {
          return resolve(null);
        });
    });
  },

  changeMemberPermissions( memberId, permissions ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/accountmanagement/permissions/${memberId}`, {
          permissions,
        })
        .then( ({data}) => {
          return resolve(data);
        })
        .catch(() => {
          return resolve(null);
        });
    });
  },

  getEmailList( memberId ) {
    return new Promise((resolve) => {
      return Services
        .get(`api/accountmanagement/emaillist/${memberId}`)
        .then( ({data}) => {
          if (data && data.success && Array.isArray(data.emails)) {
            return resolve(data.emails);
          }
          return resolve([]);
        })
        .catch(() => {
          return resolve([]);
        });
    });
  },

  sendVerificationEmail( memberId ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/accountmanagement/sendverificationemail/${memberId}`)
        .then( ({data}) => {
          if (data && data.success) {
            return resolve(true);
          }
          return resolve(false);
        })
        .catch(() => {
          return resolve(false);
        });
    });
  }
}